const TableFilterButton = ({ label, value, onClick, className = "" }) => (
  <button
    type="button"
    className={`search-input table-standard-filter-button ${className}`.trim()}
    onClick={(event) => {
      event.stopPropagation();
      onClick?.(event);
    }}
  >
    <span>
      {label} : <span className="font-semibold">{value}</span>
    </span>
    <i className="fas fa-chevron-down table-standard-filter-icon" aria-hidden />
  </button>
);

export default TableFilterButton;
